// extracted by mini-css-extract-plugin
export default {"wrapper":"Video_wrapper__mxO2A","placeholder":"Video_placeholder__JIXl8","clickable":"Video_clickable__-yxW2"};